<h2 class="row space-between w100">
    <div>Edit User for {{ data.name }}</div>
    <rr-icon class="pointer" name="close" (click)="close()"></rr-icon>
</h2>
<mat-accordion class="w100">
    @for (comp of companyList; track comp) {
        <mat-expansion-panel
            class="w100"
            [expanded]="companyList.length == 1 ? true : false"
        >
            <mat-expansion-panel-header>
                <mat-panel-title class="row align-center justify-start w100">
                    <div class="col grow-1">
                        <div>{{ comp.name }}</div>
                        <small class="">Path: {{ comp.path }}</small>
                    </div>
                    <div class="row gap-4">
                        <rr-badge>User {{ comp.user.length || 0 }}</rr-badge>
                        <rr-badge tone="info"
                            >Invitelinks
                            {{
                                comp.companyInviteLinkList?.length || 0
                            }}</rr-badge
                        >
                        <rr-badge tone="success"
                            >Free {{ comp?.license?.freeSeats || 0 }}</rr-badge
                        >
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <!-- Invitearea -->
            <mat-accordion>
                <!--@if (comp.userGates) {
                <div class="w100 row justify-end">
                    <rr-btn
                        size="small"
                        type="Secondary"
                        (click)="openUserGateEdit(comp)"
                        >Edit User Gates</rr-btn
                    >
                </div>
            }-->
                @if (comp.companyTypeId !== 'dBvJIh-H') {
                    <mat-expansion-panel>
                        <mat-expansion-panel-header
                            ><h4>
                                Company & User Invitelinks
                            </h4></mat-expansion-panel-header
                        >
                        <div class="row gap-8 justify-end">
                        <rr-btn
                            *ngIf="comp.companyTypeId !== 'dBvJIh-H'"
                            type="Secondary"
                            size="Small"
                            iconStart="add"
                            (click)="generateInviteLink(comp.companyId)"
                            >Company Invite</rr-btn
                        >
                    </div>
                        <div class="w100 invitelist col gap-4">
                            <div
                                class="invitelink w100 col gap-4 card"
                                *ngFor="let link of comp.companyInviteLinkList"
                            >
                                <div class="row gap-8 w100 space-between">
                                    <div class="row gap-8">
                                        <rr-btn
                                            type="link"
                                            size="Small"
                                            (btnclick)="copyLink(link)"
                                            >Copy Link</rr-btn
                                        >
                                        <div>
                                            {{
                                                link.expire
                                                    ? (link.expire
                                                      | date: 'dd.MM.YYYY')
                                                    : 'No Expiry'
                                            }}
                                        </div>
                                    </div>
                                    <div class="row gap-8 align-center">
                                        <rr-btn
                                            size="Small"
                                            type="Link"
                                            (click)="
                                                deleteInviteLink(
                                                    link.id,
                                                    link.companyId
                                                )
                                            "
                                            >delete Link</rr-btn
                                        >
                                        <rr-btn
                                            size="Small"
                                            type="Secondary"
                                            (click)="editInviteLink(link)"
                                            >Edit Link</rr-btn
                                        >
                                    </div>
                                </div>
                                @if (link.companyUserId) {
                                    <div class="row gap-8">
                                        <rr-badge
                                            >Coach: {{ link.prename }}
                                            {{ link.lastname }},
                                            {{ link.email }}
                                        </rr-badge>
                                    </div>
                                }
                                <div class="row gap-8">
                                    <rr-badge
                                        >Validation:
                                        {{
                                            link.invitationProcessType
                                        }}</rr-badge
                                    >
                                    <rr-badge
                                        >Usergate:
                                        {{
                                            link.usergate ? 'YES' : 'NO'
                                        }}</rr-badge
                                    >

                                    <rr-badge>
                                        Custom Login Form:
                                        {{
                                            (link.loginForm || link.customLoginFormData) ? 'YES' : 'NO'
                                        }}</rr-badge
                                    >
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                }
                <mat-expansion-panel
                    [expanded]="comp.companyTypeId === 'dBvJIh-H'"
                >
                    <mat-expansion-panel-header
                        ><h4>Company User</h4>
                    </mat-expansion-panel-header>

                    <!-- UserArea -->
                    <h3
                        class="row justify-end"
                        *ngIf="(comp?.license?.freeSeats || 0) >= 1"
                    >
                        <div class="row gap-8">
                            <rr-btn
                                type="Secondary"
                                size="Small"
                                iconStart="add"
                                *ngIf="
                                    openAddUser === false &&
                                    openEditUser === false
                                "
                                (click)="openAddUser = true"
                                >new User</rr-btn
                            >
                        </div>
                        <rr-icon
                            name="close"
                            class="pointer"
                            *ngIf="
                                openAddUser === true || openEditUser === true
                            "
                            (click)="closeUserDetails()"
                        ></rr-icon>
                    </h3>
                    <div
                        class="addarea"
                        *ngIf="openAddUser === true || openEditUser === true"
                    >
                        <div class="row gap-8">
                            <rr-input
                                label="Prename"
                                [required]="true"
                                [(ngModel)]="newUser.prename"
                            ></rr-input>
                            <rr-input
                                label="Lastname"
                                [required]="true"
                                [(ngModel)]="newUser.lastname"
                            ></rr-input>
                        </div>
                        <rr-input
                            label="Email"
                            [required]="true"
                            [(ngModel)]="newUser.email"
                        ></rr-input>
                        <div class="col rolelist gap-4">
                            <label for="" class="w100"
                                >Roles<span
                                    class="danger"
                                    *ngIf="newUser.role.length == 0"
                                    >. Please select minimum one</span
                                >
                                *</label
                            >
                            <fieldset class="w100 row gap-8 wrap-true">
                                <legend>User Roles</legend>
                                @for (role of roleList; track role.id) {
                                    <rr-checkbox
                                        class="roleitem"
                                        (click)="onRoleSelect()"
                                        [checked]="role.active || false"
                                        [(ngModel)]="role.active"
                                        *ngIf="role.type === 'USER'"
                                        >{{ role.name }}</rr-checkbox
                                    >
                                }
                            </fieldset>
                            <hr class="w100" />
                            <fieldset class="w100 row gap-8 wrap-true">
                                <legend>System Roles</legend>
                                @for (role of roleList; track role.id) {
                                    <rr-checkbox
                                        class="roleitem"
                                        (click)="onRoleSelect()"
                                        [checked]="role.active || false"
                                        [(ngModel)]="role.active"
                                        *ngIf="role.type === 'SYSTEM'"
                                        >{{ role.name }}</rr-checkbox
                                    >
                                }
                            </fieldset>
                        </div>
                        <div
                            class="row gap-8 justify-end btnrow align-center"
                            *ngIf="openAddUser === true"
                        >
                            <div>
                                By clicking the Add Button. The License of the
                                Company will be reduced by 1. The User will be
                                invited by E-Mail.
                            </div>
                            <rr-btn
                                size="Medium"
                                type="Secondary"
                                (click)="closeUserDetails()"
                                >Cancel</rr-btn
                            >
                            <rr-btn
                                size="Medium"
                                type="Primary"
                                (click)="
                                    addNewUser(comp.license, comp.companyId)
                                "
                                >Add</rr-btn
                            >
                        </div>
                        <div
                            class="row gap-8 justify-end btnrow align-center"
                            *ngIf="openEditUser === true"
                        >
                            <div class="grow-1"></div>
                            <rr-btn
                                size="Medium"
                                type="Secondary"
                                (click)="closeUserDetails()"
                                >Cancel</rr-btn
                            >
                            <rr-btn
                                size="Medium"
                                type="Primary"
                                (click)="saveUser()"
                                >Save</rr-btn
                            >
                        </div>
                    </div>
                    <div class="userlist col w100 gap-4">
                        <div
                            class="user space-between w100 row align-center status-{{
                                user.status ? user.status : 'unknown'
                            }}"
                            *ngFor="let user of comp.user"
                            title="Status of user: {{ user.status }}"
                        >
                            <div class="col">
                                <div>
                                    {{ user.prename }} {{ user.lastname }} |
                                    {{ user.email }}
                                </div>
                                <div class="row gap-4 wrap-true">
                                    <rr-badge *ngFor="let r of user.role">{{
                                        r
                                    }}</rr-badge>
                                </div>
                            </div>
                            <div class="row gap-4 align-center">
                                <rr-btn
                                    type="link"
                                    size="Small"
                                    iconStart="trash"
                                    (click)="
                                        deleteUserFromCompany(
                                            user,
                                            comp.companyId,
                                            comp.license
                                        )
                                    "
                                    >Delete</rr-btn
                                >
                                <rr-btn
                                    *ngIf="comp.companyTypeId !== 'dBvJIh-H'"
                                    type="link"
                                    class="nowrap"
                                    (click)="
                                        generateInviteLink(
                                            comp.companyId,
                                            user.id
                                        )
                                    "
                                    >User Invite</rr-btn
                                >

                                <rr-btn
                                    type="Secondary"
                                    size="Small"
                                    iconStart="edit"
                                    (click)="editUser(user)"
                                    >Edit</rr-btn
                                >
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </mat-expansion-panel>
    }
</mat-accordion>

<rr-spinner *ngIf="loading === true"></rr-spinner>
